import React, { useEffect,useState } from "react";
import Banner from "../component/Banner";
import Layout from "../component/Layout/Layout";
import CatagoryHome from "../component/CatagoryHome";
import axios from 'axios';
import { useAuth } from "../context/auth";
import { Link } from "react-router-dom";
import TestimonialHome from "../component/TestimonialHome";
import Reels from "../staticpages/Reels";
import Store from "../component/Homecomponent/Store";
import Instagram from "../component/Homecomponent/Instagram";
import ReadyToShip from "../component/Homecomponent/ReadyToShip";
import StoreNew from "../component/Homecomponent/StoreNew";
import MaansiAndKetan from "../component/Homecomponent/MaansiAndKetan";
import NewCatagory from "../component/Homecomponent/NewCatagory";
import Couture from "../component/Homecomponent/Couture";
import AboutChaashni from "../component/Homecomponent/AboutChaashni";
import HomeBanner from "../component/Homecomponent/HomeBanner";
import CelebrityScroll from "../component/Homecomponent/CelebrityScroll";
import VideoGallery from "../component/Homecomponent/VideoGallery";
import HomeVideo from "../component/Homecomponent/HomeVideo";
import WomenOfChaashni from "../component/Homecomponent/WomenOfChaashni";
import NewWomenOfChaashni from "../component/Homecomponent/NewWomenOfChaashni";
import ShopByCategory from "../component/Homecomponent/ShopByCategory";
import NewHomecomponent from "../component/Homecomponent/NewHomecomponent";
export default function NewHome() {
  const [lauth, setLauth] = useAuth();
  const [validated, setValidated] = useState(false);
  const [fromResMsg, setfromResMsg] = useState('');
  const [fromResError, setfromResError] = useState('');
  const [formData, setFormData] = useState({
    email: ''
  });
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleSubmit = async(e) => {
    setfromResMsg('');
    setfromResError('');
    e.preventDefault();
    const form = e.currentTarget;
    setValidated(true);
    if(form.checkValidity()===true) {
      //console.log('Form submitted:', formData);
      try {
         const {data} = await axios.post(`${process.env.REACT_APP_API_URL}/subscription`, formData);
          //console.log(data);
          setValidated(false);
          setFormData({
            email: ''
          });
          setfromResMsg(data.message);
          
      } catch (error) {
        const {data} = error.response;
        setfromResError(data[0].message);
      }
    }   
  };
  useEffect(() => {
    document.body.classList.add('home-layout')
    return () => {
      document.body.classList.remove('home-layout')
    }
  }, [])
  return (
<Layout title="Chaashni by Maansi &amp; Ketan"  description="Abode of designer Lehengas, Gowns, Sarees, Indo Westerns and Western Dresses. SHIPPING WORLDWIDE." > {/* JSON.stringify(lauth, null,4) */}
  <div className="site-content new-home-design"> <HomeBanner />
  {/*  <div className="home-full homegroth-wrap">
      <div className="container">
        <div className="row  three-tab-wrap">
          <div className="col-md-4 col-sm-4 col-xs-4">
            <div className="three-tab">
              <div className="img-box"> <img src="../images/endless-personalised-icon.png" width="50px" height="50px"  alt="ENDLESS PERSONALISATION" loading="lazy"  /> </div>
              <h3>ENDLESS PERSONALISATION</h3>
              <p><strong>Video Calls</strong>, Custom Stitching, Alterations,  <br /> Customisation and <strong> Consultations with </strong> <br /> <strong>Style Executives</strong>. Shopping with us is like <br /> shopping at a physical store. </p>
            </div>
          </div>
          <div className="col-md-4 col-sm-4 col-xs-4">
            <div className="three-tab">
              <div className="img-box"> <img src="../images/custom-tailoring-icon.png"  width="50px" height="50px"  alt="CUSTOM TAILORING" loading="lazy" /> </div>
              <h3>CUSTOM TAILORING</h3>
              <p>Over the last 12 years we've made <br /> over 67,000 customers worldwide <br /> look stunning by delivering immaculately <br /> crafted <strong>'Made-to-Fit' dresses</strong>. See <Link target="_blank" to="/custom-tailoring/">How It Works</Link>.</p>
            </div>
          </div>
          <div className="col-md-4 col-sm-4 col-xs-4">
            <div className="three-tab">
              <div className="img-box"> <img src="../images/shipping-worldwide.png" width="50px" height="50px"  alt="SHIPPING WORLDWIDE" loading="lazy" /> </div>
              <h3>SHIPPING WORLDWIDE</h3>
              <p>We <strong>ship</strong> to over 24 countries <br /> around the globe. Shipping India-wide is free. <br />     International Shipping is free for orders <br /> above $250.</p>
            </div>
          </div>
        </div>
        <div className="min-heading-box">
          <p> <span> <a href="#testimonial-home"> Read what our customers have to say for us </a> </span> </p>
        </div>
      </div>
    </div> */}

    <NewHomecomponent />

<div className="home-full hometext-wrap" style={{"display":"none"}}>
  <div className="container">    
      <div className="hometext-tab">
        {/* <div className="lotas-flare"><img src="images/about/flare-pink.png" alt="flare-pink" /></div> */}      
        <h3 className="newfont-heading">Handcrafted . Luxurious . Exquisite . रोमांटिक{/* HANDCRAFTED. LUXURIOUS. EXQUISITE */}</h3>
        <p>Chaashni, meaning 'Sugar Syrup' in Hindi, is a women's designer wear label<br/> dedicated to capturing the sweetness and richness of timeless elegance.</p>
        <p>We specialise in Couture and Pret garments, creating pieces<br/>  that blend traditional craftsmanship with modern sophistication.</p>
        <p>Indulge in our collections and let us add a touch of elegance to your journey.</p>
        <div className="lotas-box"><img src="images/about/Lotus-pink.png" alt="" /></div>      
    </div>
  </div>
</div>
<AboutChaashni />

{/* <ShopByCategory /> */}

{/* <VideoGallery /> */}

{/* comment on 10sep26 <NewWomenOfChaashni /> */}

{/* <NewCatagory /> */}

{/* comment on 10sep26 <Couture /> */}

{/* <CelebrityScroll /> */}
{/* <ReadyToShip /> */}

{/* <HomeVideo /> */}
{/* <WomenOfChaashni /> */}

{/* <Instagram /> */}
    {/* <CatagoryHome /> */}
    {/*  <div className="reels-box">
      <Reels />
    </div> */}   
   {/*  <MaansiAndKetan /> */}
    <div className="storenew-box"><StoreNew /></div>    
    <div className="home-full homegroth-wrap">
      <div className="container">
        {/* <div className="newsletter-box"> <span id="hsuccess" />
          <div className="newsletter-left">
            <h2> Stay Updated with our <strong>Latest Launches</strong>, <br />
              <span>Give-aways</span> and <strong>Discount Coupons.</strong> </h2>
            <p>Only meaningful rare messages. That's a promise.</p>
          </div>
          <div className="newsletter-right">
            <form
                  className="form-inline googleform"
                  id="form"
                  method="post"
                  action=""
                  noValidate 
                  validated={validated} 
                  onSubmit={handleSubmit}
                >
             
              <div className="googleform-box">
                <input
                      type="email"
                      name="email"
                      required
                      placeholder="Your Email"
                      className="form-control"
                      onChange={handleChange} 
                      value={formData.email}
                    />  
                {fromResMsg && (
                     <label className="success-msg">{fromResMsg}</label>
                  )}   
                  {fromResError && (
                    <label className="text-danger">{fromResError}</label>
                 )}                            
              </div>
              <input type="submit" value="SIGN UP" className="btn btn-primary" />
            </form>
          </div>
        </div> */}
       {/* <TestimonialHome />  */}      
        {/* <div className="chaashni-luv-stories"><Link to="/testimonial" target="_blank">View more Chaashni Love Stories and Pictures</Link></div>
        <div className="google-wrap"><Link target="_blank" to="https://tinyurl.com/2n7h2ddy"><img src="../images/Google-reviews2.png" width="225px" height="41px" alt="" loading="lazy"/></Link></div> */}
        {/* <div className="ade-wrap">
          <div className="ade-box">
            <picture>
              <source media="(min-width:768px)" srcSet="../images/Homepage-Icons-v4.svg?var-2" />
              <source media="(min-width:1px)" srcSet="../images/Homepage-Mobile-Icons-v4.svg?var-2" />
              <img src="../images/Homepage-Icons-v4.svg?var-2" width="1000px" height="85px" alt="" loading="lazy" />
            </picture>
          </div>
        </div> */}
      </div>
    </div>
  </div>
</Layout>
);
} 